import { useState, useRef } from 'react';

/**
 * useDialog - Async dialog state hook.
 *
 * Provides a Promise-based dialog flow: call showDialogAsync() to open a dialog
 * and await the user's response. handleDialogClose() resolves the promise.
 *
 * Usage:
 *   const { dialog, showDialogAsync, handleDialogClose } = useDialog();
 *   const name = await showDialogAsync("prompt", "Enter name:", "");
 */
export default function useDialog() {
  const [dialog, setDialog] = useState(null);
  const dialogResolveRef = useRef(null);

  const showDialogAsync = (type, message, defaultValue) => {
    return new Promise((resolve) => {
      dialogResolveRef.current = resolve;
      if (type === 'choice') {
        // defaultValue is { choices: [{ label, value }, ...] }
        setDialog({ type, message, choices: defaultValue?.choices || [] });
      } else {
        setDialog({ type, message, defaultValue: defaultValue || '' });
      }
    });
  };

  const handleDialogClose = (result) => {
    setDialog(null);
    if (dialogResolveRef.current) {
      dialogResolveRef.current(result);
      dialogResolveRef.current = null;
    }
  };

  return { dialog, showDialogAsync, handleDialogClose };
}
